import {
  EAiAssistSource,
  EItemAiAction,
} from '../../../../shared/components/ai-assist-shell/ai-assist-shell.interface';
import { ISegmentedButtonOption } from '../../../../shared/components/segmented-button/segmented-button.interface';

/** These quick actions work on the existing description, so they are off while the description is empty. */
export const AI_ASSIST_ACTIONS_REQUIRING_DESCRIPTION: readonly EItemAiAction[] = [
  EItemAiAction.fixDescription,
  EItemAiAction.shorten,
];

const MODES_I18N = 'page.artificialIntelligence.assistDialog.modes';

/** A saved item offers both: edit (a suggestion for the form) and report (to read only, nothing is applied). */
export const AI_ASSIST_ITEM_MODES: ISegmentedButtonOption<EAiAssistSource>[] = [
  {
    icon: 'edit_note',
    labelKey: `${MODES_I18N}.edit`,
    tooltipKey: `${MODES_I18N}.editHint`,
    value: EAiAssistSource.itemModal,
  },
  {
    icon: 'insights',
    labelKey: `${MODES_I18N}.report`,
    tooltipKey: `${MODES_I18N}.reportHint`,
    value: EAiAssistSource.itemReport,
  },
];
